import React, { useEffect, useState } from "react";
import styled from "styled-components";
import IconSAT from '../../assets/images/icon-sat.svg'
import IconSurvey from '../../assets/images/icon-survey.svg'
import ButtonComponent from "../button";
import IconCheck from "../../assets/images/icon-check.svg"
import IconLocation from '../../assets/images/icon-location-1.svg'

const Container = styled.div`
    width: 100%;
    /* height: 100%; */
`;

const Banner = styled.div`
    width: calc(100% - 16px);
    height: 112px;
    background: linear-gradient(153.06deg, rgba(246, 210, 133, 0.3) -0.31%, rgba(187, 240, 243, 0.3) 99.69%);
    display: flex;
    padding: 0px 8px;
    position: relative;

    .icon-survey-box {
        width: 114px;
        .icon-survey {
            width: 122px;
        }
    }

    .label {
        width: 200px;
        color: #25368D;
        font-size: 16px;
        font-weight: 500;
        line-height: 23.92px;
        text-align: center;
    }

    .icon-sat {
        position: absolute;
        top: 8px;
        right: 8px;
    }
`;

const Body = styled.div`
    width: calc(100% - 48px);
    height: calc(100% - 160px);
    padding: 24px;
    display: flex;
    flex-direction: column;

    .description {
        color: #2A2A2A;
        font-size: 20px;
        font-weight: 400;
        line-height: 29.9px;
        text-align: left;
        margin-bottom: 4px;
    }
    .title {
        color: #25368D;
        font-size: 24px;
        font-weight: 500;
        line-height: 35.88px;
        text-align: left;
        margin-bottom: 12px;
    }

    .button-box {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        margin-top: 48px;
        gap: 24px;
    }
`;

const CheckBox = styled.div`
    /* height: 52px; */
    border-radius: 13px;
    border: 1px solid #F1F1F190;
    box-shadow: 0px 5px 14px 0px #00266F11;
    margin-bottom: 8px;
    /* padding: 0px 16px; */
    color: #505050;
    font-size: 15px;
    font-weight: 400;
    line-height: 22.43px;
    text-align: left;
    cursor: pointer;

    &.active {
        color: #25368D;
    }

    &.disable {
        cursor: default;
    }

    .box {
        width: 16px;
        height: 16px;
        min-width: 16px;
        margin-left: 1px;
        margin-right: 12px;
        border-radius: 2px;
        border: 1px solid #505050;

        &.active {
            background-color:  #FBE250;
            border: 1px solid #FBE250;
        }
    }

    .main-box {
        width: calc(100% - 32px);
        min-height: 46px;
        padding: 4px 16px;
    }
`;

const Card = styled.div`
    min-height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 13px;
    border: 1px solid #F1F1F190;
    box-shadow: 0px 5px 14px 0px #00266F11;
    margin-bottom: 8px;
    padding: 16px;
    cursor: pointer;

    .label-title {
        color: #25368D;
        font-size: 15px;
        font-weight: 400;
        line-height: 22.43px;
        text-align: left;
    }

    .label-sub-title {
        color: #505050;
        font-size: 14px;
        font-weight: 300;
        line-height: 20.93px;
        text-align: left;
        padding-top: 2px;
    }
`;

function EvaluationFormLanding({
    evaluationForm,
    haveHistory,
    evaluator,
    onConfirm,
}) {
    const [value, setValue] = useState(false);
    const [consent, setConsent] = useState(false);

    useEffect(() => {
        setConsent(evaluator?.consent ? true : false)
    }, [evaluator])

    function handleClick(param) {
        if (!consent && !value) return
        onConfirm && onConfirm(param);
    }
    function handleChange() {
        const _value = !value;
        setValue(_value)
    }

    return (
        <Container>
            <Banner>
                <div className="icon-survey-box vertical-center"><img alt="img" className="icon-survey" src={IconSurvey} /></div>
                <div className="label vertical-center">ยินดีต้อนรับสู่แบบสอบถาม<br />จากการกีฬาแห่งประเทศไทย</div>
                <div className="icon-sat"><img alt="img" src={IconSAT} /></div>
            </Banner>
            <Body>
                <div className="description">แบบประเมิน</div>
                <Card>
                    <div className="label-title">{evaluationForm?.evaluation_form_evaluation_type === "Place" ? evaluationForm?.location_location_name || "" : evaluationForm?.evaluation_form_evaluation_data?.title || ""}</div>
                    {evaluationForm?.evaluation_form_evaluation_type === "Place" &&
                        <div className="vertical-center" style={{ marginTop: "4px" }}>
                            <img alt="img" src={IconLocation} style={{ marginRight: "8px" }} />
                            <div className="label-sub-title"> {evaluationForm?.location_province || ""}</div>
                        </div>
                    }
                </Card>
                {!consent &&
                    <CheckBox className={`${value ? "active" : ""}`}>
                        <div className="vertical-center main-box" onClick={handleChange}>
                            <div className={`content-center box ${value ? "active" : ""}`}>
                                {value && <img alt="img" src={IconCheck} />}
                            </div>
                            การยืนยันเข้าทำแบบประเมิน ถือเป็นการยอมรับข้อกำหนด PDPA โดย กกท. จะนำข้อมูลไปใช้เพื่อพัฒนาบริการให้ดีขึ้นเท่านั้น
                        </div>
                    </CheckBox>
                }
                <div className="button-box">
                    {haveHistory &&
                        <ButtonComponent
                            label={"ยืนยันคำตอบเดิม"}
                            variant={"primary"}
                            disable={consent ? false : !value}
                            onClick={(e) => handleClick("old")}
                        />
                    }
                    <ButtonComponent
                        label={"ทำแบบประเมิน"}
                        variant={"primary"}
                        disable={consent ? false : !value}
                        onClick={(e) => handleClick("new")}
                    />
                </div>
            </Body>
        </Container>
    )
}

export default EvaluationFormLanding;